export const upsert = async (userId, list, data, token) => {
    try {
        const res = await fetch('/api/watchlist/upsert', {
            method: "POST",
            headers: {'x-access-token': token},
            body: JSON.stringify({
                userId,
                list,
                data,
            })
        })
        return await res.json();
    } catch (error) {
        console.error(error);
    }
}